import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import styled, { css } from 'styled-components';

import { theme } from '../../../common/ui/theme';

const slimVariantChildrenStyles = css({
    '> *': {
        width: 'auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: '1 1 0',
        minWidth: 0,
        maxWidth: 'max-content',
    },
});

export const RadioCardVariants = {
    DEFAULT: 'default',
    SLIM: 'slim',
} as const;

export type RadioCardVariantsType = (typeof RadioCardVariants)[keyof typeof RadioCardVariants];

interface RadioCardProps extends RadixRadioGroup.RadioGroupItemProps {
    $variant: RadioCardVariantsType;
}

export const RadioCard = styled(RadixRadioGroup.Item)<RadioCardProps>`
    min-width: 168px;
    padding: ${theme.space[8]} ${theme.space[16]};
    display: flex;
    flex-direction: ${({ $variant }) => {
        switch ($variant) {
            case RadioCardVariants.SLIM:
                return 'row';
            case RadioCardVariants.DEFAULT:
                return 'column';
        }
    }};
    justify-content: start;
    flex: 1 0 0;
    gap: ${({ $variant }) => ($variant === RadioCardVariants.SLIM ? theme.space[8] : '0')};

    border: none;
    border-radius: ${theme.radii[8]};
    box-shadow: inset 0 0 0 1px ${theme.colors.border.muted};
    background: ${theme.colors.background.default};

    * {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        text-align: left;
    }

    ${({ $variant }) => ($variant === RadioCardVariants.SLIM ? slimVariantChildrenStyles : null)}

    transition: all 100ms ease-in-out;

    &:hover,
    &:focus {
        box-shadow: inset 0 0 0 1px ${theme.colors.accent.foreground};
    }

    &[data-state='checked'] {
        box-shadow: inset 0 0 0 2px ${theme.colors.accent.foreground};
        background-color: ${theme.colors.accent.background};

        * {
            color: ${theme.colors.accent.foreground};
        }
    }
`;
